// extracted by mini-css-extract-plugin
module.exports = {"leadItem":"PendingAndOldLeadCard_leadItem__2Bt3M","skeletonListItem":"PendingAndOldLeadCard_skeletonListItem__1cvAs"};